module.exports = __webpack_public_path__ + "static/media/create-project-illustration.a4af55d6.jpg";